import { getImageUrl } from '@utils/getImageUrl'
import * as css from './styles'

export const Header = ({ name, slug }) => {
  return (
    <css.DrawerHeader css={{ display: 'flex', alignItems: 'center' }}>
      <img src={getImageUrl(slug)} alt={name} style={{ height: '24px' }} />
      <css.DrawerHeaderTitle>{name}</css.DrawerHeaderTitle>
    </css.DrawerHeader>
  )
}
